import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Select, { MultiValue } from 'react-select';
import DatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';

type SelectOption = { value: string; label: string };

interface ProdutoQuantidade {
    produto: SelectOption;
    quantidade: number;
}

interface FormData {
    id: string;
    dataInicio: Date | null;
    dataFechamento: Date | null;
    descricao: string;
    produtosQuantidades: ProdutoQuantidade[];
    fornecedor: SelectOption | null;
    licitante: SelectOption | null;
    totalOrcado: string;
    percentualComparativo: string;
    situacao: SelectOption | null;
    usuario: SelectOption | null;
}

const AddOrcamentoForm = () => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    // Estado do formulário
    const [formData, setFormData] = useState<FormData>({
        id: '',
        dataInicio: new Date(),
        dataFechamento: null,
        descricao: '',
        produtosQuantidades: [],
        fornecedor: null,
        licitante: null,
        totalOrcado: '',
        percentualComparativo: '',
        situacao: null,
        usuario: null
    });

    // Opções para os selects
    const produtosOptions = [
        { value: 'sistema1', label: 'Sistema de Gestão Municipal' },
        { value: 'sistema2', label: 'Portal da Transparência' },
        { value: 'sistema3', label: 'Sistema de Gestão de RH' },
        { value: 'sistema4', label: 'Sistema de Controle de Patrimônio' },
        { value: 'sistema5', label: 'Sistema de Gestão Tributária' }
    ];

    const fornecedorOptions = [
        { value: 'fornecedor1', label: 'TechSoft Solutions' },
        { value: 'fornecedor2', label: 'Municipal Systems SA' },
        { value: 'fornecedor3', label: 'Govtech Brasil LTDA' },
        { value: 'fornecedor4', label: 'Software Público Inc' }
    ];

    const licitanteOptions = [
        { value: 'prefeituraSP', label: 'Prefeitura de São Paulo' },
        { value: 'govSP', label: 'Governo do Estado de São Paulo' },
        { value: 'prefeituraRJ', label: 'Prefeitura do Rio de Janeiro' },
        { value: 'ufmg', label: 'Universidade Federal de Minas Gerais' }
    ];

    const situacaoOptions = [
        { value: 'negociando', label: 'Negociando' },
        { value: 'finalizado', label: 'Finalizado' },
        { value: 'cancelado', label: 'Cancelado' }
    ];

    const usuarioOptions = [
        { value: 'user1', label: 'João Silva' },
        { value: 'user2', label: 'Maria Santos' },
        { value: 'user3', label: 'Carlos Oliveira' }
    ];

    // Handler para formatar valor em Reais
    const handleCurrencyInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, '');
        const formattedValue = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(Number(value) / 100);
        setFormData({ ...formData, [e.target.name]: formattedValue });
    };

    // Handler para adicionar produto e quantidade
    const handleAddProdutoQuantidade = () => {
        setFormData({
            ...formData,
            produtosQuantidades: [
                ...formData.produtosQuantidades,
                { produto: produtosOptions[0], quantidade: 1 }
            ]
        });
    };

    // Handler para remover produto e quantidade
    const handleRemoveProdutoQuantidade = (index: number) => {
        const newProdutosQuantidades = [...formData.produtosQuantidades];
        newProdutosQuantidades.splice(index, 1);
        setFormData({ ...formData, produtosQuantidades: newProdutosQuantidades });
    };

    // Handler para atualizar produto e quantidade
    const handleUpdateProdutoQuantidade = (
        index: number,
        field: 'produto' | 'quantidade',
        value: any
    ) => {
        const newProdutosQuantidades = [...formData.produtosQuantidades];
        newProdutosQuantidades[index] = {
            ...newProdutosQuantidades[index],
            [field]: value
        };
        setFormData({ ...formData, produtosQuantidades: newProdutosQuantidades });
    };

    return (
        <>
            {/* Botão de Adicionar */}
            <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas_add_quotation"
            >
                <i className="ti ti-square-rounded-plus me-2" />
                Adicionar Orçamento
            </Link>

            {/* Formulário Offcanvas */}
            <div
                className="offcanvas offcanvas-end offcanvas-large"
                tabIndex={-1}
                id="offcanvas_add_quotation"
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="mb-0">Novo Orçamento</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                    >
                        <i className="ti ti-x" />
                    </button>
                </div>
                <div className="offcanvas-body">
                    <form>
                        <div className="row">
                            {/* ID */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    ID <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    disabled
                                />
                            </div>

                            {/* Data de Início */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Data de Início <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                    className="form-control"
                                    selected={formData.dataInicio}
                                    onChange={(date: Date | null) =>
                                        setFormData({ ...formData, dataInicio: date })}
                                    dateFormat="dd/MM/yyyy"
                                />
                            </div>

                            {/* Data de Fechamento */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Data de Fechamento
                                </label>
                                <DatePicker
                                    className="form-control"
                                    selected={formData.dataFechamento}
                                    onChange={(date: Date | null) =>
                                        setFormData({ ...formData, dataFechamento: date })}
                                    dateFormat="dd/MM/yyyy"
                                />
                            </div>

                            {/* Descrição */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">
                                    Descrição <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="descricao"
                                    value={formData.descricao}
                                    onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                                />
                            </div>

                            {/* Produtos e Quantidades */}
                            <div className="col-md-12 mb-3">
                                <label className="form-label">
                                    Produtos e Quantidades <span className="text-danger">*</span>
                                </label>
                                {formData.produtosQuantidades.map((item, index) => (
                                    <div key={index} className="row mb-2">
                                        <div className="col-md-6">
                                            <Select
                                                value={item.produto}
                                                onChange={(option) =>
                                                    handleUpdateProdutoQuantidade(index, 'produto', option)}
                                                options={produtosOptions}
                                                className="select2"
                                                classNamePrefix="react-select"
                                                placeholder="Selecione o produto"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={item.quantidade}
                                                onChange={(e) =>
                                                    handleUpdateProdutoQuantidade(
                                                        index,
                                                        'quantidade',
                                                        parseInt(e.target.value)
                                                    )}
                                                min="1"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => handleRemoveProdutoQuantidade(index)}
                                            >
                                                <i className="ti ti-trash" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleAddProdutoQuantidade}
                                >
                                    <i className="ti ti-plus me-2" />
                                    Adicionar Produto
                                </button>
                            </div>

                            {/* Fornecedor */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Fornecedor <span className="text-danger">*</span>
                                </label>
                                <Select
                                    value={formData.fornecedor}
                                    onChange={(option) =>
                                        setFormData({ ...formData, fornecedor: option })}
                                    options={fornecedorOptions}
                                    className="select2"
                                    classNamePrefix="react-select"
                                    placeholder="Selecione o fornecedor"
                                />
                            </div>

                            {/* Licitante */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Licitante <span className="text-danger">*</span>
                                </label>
                                <Select
                                    value={formData.licitante}
                                    onChange={(option) =>
                                        setFormData({ ...formData, licitante: option })}
                                    options={licitanteOptions}
                                    className="select2"
                                    classNamePrefix="react-select"
                                    placeholder="Selecione o licitante"
                                />
                            </div>

                            {/* Total Orçado */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Total Orçado <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="totalOrcado"
                                    value={formData.totalOrcado}
                                    onChange={handleCurrencyInput}
                                    placeholder="R$ 0,00"
                                />
                            </div>

                            {/* Percentual Comparativo */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Percentual Comparativo
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="percentualComparativo"
                                    value={formData.percentualComparativo}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            percentualComparativo: e.target.value
                                        })}
                                    placeholder="0%"
                                />
                            </div>

                            {/* Situação */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Situação <span className="text-danger">*</span>
                                </label>
                                <Select
                                    value={formData.situacao}
                                    onChange={(option) =>
                                        setFormData({ ...formData, situacao: option })}
                                    options={situacaoOptions}
                                    className="select2"
                                    classNamePrefix="react-select"
                                    placeholder="Selecione a situação"
                                />
                            </div>

                            {/* Usuário */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Usuário <span className="text-danger">*</span>
                                </label>
                                <Select
                                    value={formData.usuario}
                                    onChange={(option) =>
                                        setFormData({ ...formData, usuario: option })}
                                    options={usuarioOptions}
                                    className="select2"
                                    classNamePrefix="react-select"
                                    placeholder="Selecione o usuário"
                                />
                            </div>
                        </div>

                        {/* Botões de ação */}
                        <div className="d-flex justify-content-end mt-4">
                            <button
                                type="button"
                                className="btn btn-light me-2"
                                data-bs-dismiss="offcanvas"
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setOpenModal(true)}
                            >
                                Salvar
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Modal de Sucesso */}
            <Modal show={openModal} onHide={() => setOpenModal(false)} centered>
                <Modal.Body className="text-center">
                    <div className="mb-4">
                        <div className="avatar avatar-lg bg-success-light rounded-circle mb-2">
                            <i className="ti ti-check fs-24 text-success" />
                        </div>
                        <h5 className="mb-2">Orçamento Criado com Sucesso!</h5>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn btn-light me-2"
                            onClick={() => setOpenModal(false)}
                        >
                            Fechar
                        </button>
                        <button className="btn btn-primary">
                            Ver Detalhes
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddOrcamentoForm;